import { createPopper } from '@popperjs/core';

function showTooltip(popperInstance, popoverID) {
    // Make the tooltip visible
    document.getElementById(popoverID)?.classList.remove('tw-hidden');
    document.getElementById(popoverID)?.classList.add('tw-flex');

    // Enable the event listeners
    popperInstance.setOptions((options) => ({
        ...options,
        modifiers: [...options.modifiers, { name: 'eventListeners', enabled: true }],
    }));

    // Update its position
    popperInstance.update();
}

function hideTooltip(popperInstance, popoverID) {
    // Hide the tooltip
    document.getElementById(popoverID)?.classList.add('tw-hidden');
    document.getElementById(popoverID)?.classList.remove('tw-flex');

    // Disable the event listeners
    popperInstance.setOptions((options) => ({
        ...options,
        modifiers: [...options.modifiers, { name: 'eventListeners', enabled: false }],
    }));

    // Remove the tooltip
    $(`#${popoverID}`).remove();
}

function initializeIndividualTooltip($triggerEl, container = 'body', template = '') {
    const dataAttributes = $($triggerEl).data();

    let tooltipTitle = $($triggerEl).attr('title');
    let tooltipPlacement = 'bottom';
    let tooltipHtml = false;
    let tooltipContent = '';

    if (dataAttributes) {
        tooltipPlacement = dataAttributes.placement ? dataAttributes.placement : tooltipPlacement;
        tooltipHtml = dataAttributes.html ? true : false;
        tooltipContent = dataAttributes.content;
    }

    if (tooltipTitle == undefined || tooltipTitle == '') {
        tooltipTitle = $($triggerEl).attr('data-original-title');
    }

    // To avoid browser default title behavior
    if (tooltipTitle != undefined && tooltipTitle != '') {
        $($triggerEl).attr('title', null);
        $($triggerEl).attr('data-original-title', tooltipTitle);
    }

    // Populating tooltip content if data-html attribute is present
    let tooltipTemplate = '';
    if (tooltipHtml) {
        tooltipTemplate =
            dataAttributes.type == 'popover'
                ? template
                : `<div id="tooltip" role="tooltip" class="tw-z-[1024] tw-flex-col tw-gap-y-2 tw-bg-charcoal-50 tw-p-3 tw-rounded-lg tw-border-0 tw-hidden">
                <div class="tooltip-inner tw-p-0 tw-text-sm tw-text-white tw-font-medium tw-bg-transparent">` +
                  tooltipContent +
                  `</div>
            </div>`;

        // Populating tooltip content if data-html attribute is not present
    } else {
        tooltipTemplate =
            dataAttributes.type == 'popover'
                ? template
                : `<div id="tooltip" role="tooltip" class="tw-z-[1024] tw-flex-col tw-gap-y-2 tw-bg-charcoal-50 tw-p-3 tw-rounded-lg tw-border-0 tw-hidden">
                <div class="tooltip-inner tw-p-0 tw-text-sm tw-text-white tw-font-medium tw-bg-transparent">` +
                  tooltipTitle +
                  `</div>
            </div>`;
    }

    if (tooltipTemplate != undefined && tooltipTemplate != '') {
        // Remove any existing tooltip
        $('#tooltip').remove();

        $(document).find(container).append(tooltipTemplate);

        if (dataAttributes.type == 'popover') {
            tooltipTitle = dataAttributes.title;

            // Get the element by ID
            var popoverHeader = document.getElementById('tooltip').querySelector('.popover-header');
            var popoverBody = document.getElementById('tooltip').querySelector('.popover-body');
            if (popoverHeader) {
                // Set the title
                popoverHeader.innerHTML = tooltipTitle;
            }
            if (popoverBody) {
                // Set the body
                popoverBody.innerHTML = tooltipContent;
            }
        }
        // Create popper tooltip instance
        const tooltip = document.querySelector('#tooltip');
        const popperInstance = createPopper($triggerEl, tooltip, {
            placement: tooltipPlacement,
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [0, 10],
                    },
                },
            ],
        });

        showTooltip(popperInstance, 'tooltip');

        // Add event listeners to tooltip
        const showEvents = ['mouseenter', 'focus'];
        const hideEvents = ['mouseleave', 'blur'];
        showEvents.forEach((event) => {
            $triggerEl.addEventListener(event, () => showTooltip(popperInstance, 'tooltip'));
        });
        hideEvents.forEach((event) => {
            $triggerEl.addEventListener(event, () => hideTooltip(popperInstance, 'tooltip'));
        });
    }
}

function initializeTooltips(options = null) {
    let tooltipSelector = options?.customTooltipSelector ? options?.customTooltipSelector : '[data-popper-toggle="tooltip"]';
    document.querySelectorAll(tooltipSelector).forEach(($triggerEl) => {
        const triggerEvents = ['mouseenter', 'focus'];
        triggerEvents.forEach((event) => {
            $triggerEl.addEventListener(event, () => initializeIndividualTooltip($triggerEl, 'body', options?.template));
        });
    });
}

// Initialize tooltips
initializeTooltips();

window.initializeIndividualTooltip = initializeIndividualTooltip;
window.initializeTooltips = initializeTooltips;
